// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerFile_root__fB3N1"};